<template>
  <div class="text-left lg:w-3/6 md:w-4/6 mx-auto">
    <h2 class="ui header text-center">重置登录密码</h2>
    <Loader :busy="loading">
      <div v-if="step == 'password'" class="text-left ui form">
        <div class="field">
          <label>新密码</label>
          <input id="new-pass" name="new-pass" v-model="password" type="password">
        </div>
        <div class="field">
          <label>重复输入</label>
          <div class="ui fluid input">
            <input id="new-pass-repeat" name="new-pass-repeat" v-model="password_repeat" type="password">
          </div>
        </div>
        <button @click="set_password" class="ui teal fluid button">提交</button>
      </div>
      <div v-if="step == 'email'" class="text-left ui form">
        <div class="field">
          <label>输入注册邮箱</label>
          <div class="ui fluid input">
            <input id="email" name="email" v-model="email" type="text">
          </div>
        </div>
        <button @click="send_sms" class="ui teal fluid button">下一步</button>
      </div>
      <div v-if="step == 'sms'" class="text-left ui form">
        <div class="field">
          <label>输入注册手机号收到的短信验证码</label>
          <div class="ui fluid input">
            <input id="sms_code" name="sms_code" v-model="sms_code" class="form-control" type="text">
          </div>
        </div>
        <button @click="verify_sms" class="ui teal fluid button">下一步</button>
      </div>
      <div v-if="step == 'sent'" class="text-left ui segment">
        密码重置邮件已发送至<strong class="ui teal text">{{ email }}</strong>，请登录邮箱重置密码。
      </div>
    </Loader>
  </div>
</template>

<script>
import Loader from '../components/loader.vue';

export default {
  name: '',
  props: [],
  components: {
    Loader,
  },
  data: function () {
    return {
      email: "",
      step: "",
      sms_code: "",
      password: "",
      password_repeat: "",
      loading: 0,
    };
  },
  computed: {
  },
  methods: {
    loading_begin() {
      this.loading++;
    },
    loading_end() {
      this.loading--;
    },
    send_sms() {
      if (!this.email) {
        return;
      }
      this.loading_begin();
      this.client.reset_password_request_sms(this.email).then(data => {
        this.step = 'sms';
        this.message = data.msg;
        this.loading_end();
      }).catch(e => {
        this.loading_end();
        this.show_error(e.responseJSON.detail);
      });
    },
    verify_sms() {
      if (!this.sms_code) {
        return;
      }
      this.loading_begin();
      this.client.reset_password_verify_sms(this.email, this.sms_code).then(() => {
        this.loading_end();
        this.step = "sent";
      }).catch(() => {
        this.loading_end();
      });
    },
    set_password() {
      if (!this.password) {
        this.show_error("不能为空");
        return;
      }
      if (this.password != this.password_repeat) {
        this.show_error("两次输入不一致");
        return;
      }
      this.loading_begin();
      this.client.reset_password_complete(this.$route.query.token, this.password).then(() => {
        this.message = "密码已重置"
        this.step = "";
        this.loading_end();
      }).catch(e => {
        if (e.status == 404) {
          this.show_error( "信息无效");
        } else {
          this.show_error("错误：" + e.statusText);
        } 
        this.loading_end();
      });
    },
  },
  mounted() {
    if (this.$route.query.token) {
      this.step = "password";
    } else {
      this.step = "email";
    }
  },
}
</script>

<style scoped>
.login-form {
  margin-top: 75px;
}
.footer {
  margin-top: 200px;
}
</style>
